import { IStyle, mergeStyleSets } from "@fluentui/react";

// Color tokens
const ColorTokens = {
  background: "#FFFFFF",
  foreground: "hsl(222.2, 84%, 4.9%)",
  primary: "hsl(214, 100%, 56%)",
  supportBlue: "hsl(214, 100%, 56%)",
  supportBlueLight: "hsl(213, 100%, 94%)",
  mutedForeground: "hsl(220, 8.9%, 46.1%)",
  border: "hsl(212, 90%, 88%)",
  gradientSupport: "linear-gradient(135deg, hsl(214, 100%, 56%), hsl(213, 89%, 64%))",
  gradientCard: "linear-gradient(135deg, hsl(0, 0%, 100%), hsl(213, 50%, 98%))",
  gradientBg: "#FFFFFF"
};

export const AppStyles = mergeStyleSets({
  minHeightScreen: {
    minHeight: "100vh",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
  } as IStyle,
  header: {
    borderBottom: `1px solid ${ColorTokens.border}`,
    background: "transparent",
    backdropFilter: "blur(8px)",
    position: "relative",
    zIndex: 100
  } as IStyle,
  headerContainer: {
    maxWidth: "100%",
    margin: "0 auto",
    paddingBottom: "5px"
  } as IStyle,
  headerContent: {
    textAlign: "center"
  } as IStyle,
  mainTitle: {
    marginBottom: "16px",
    fontSize: "36px",
    fontWeight: "bold",
    color: ColorTokens.foreground
  } as IStyle,
  mainDescription: {
    margin: "0 auto",
    maxWidth: "512px",
    fontSize: "18px",
    color: ColorTokens.mutedForeground
  } as IStyle,
  supportOptionsContainer: {
    maxWidth: "100%",
    margin: "0 auto",
    padding: "64px 48px",
    position: "relative",
    zIndex: 100
  } as IStyle,
  responsiveGrid: {
    display: "grid",
    gap: "32px",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto"
  } as IStyle,
  immediateAssistance: {
    backdropFilter: "blur(8px)",
    position: "relative",
    width: "100%",
    zIndex: 100
  } as IStyle,
  immediateAssistanceContainer: {
    maxWidth: "100%",
    margin: "0 auto",
    padding: "32px 48px"
  } as IStyle,
  immediateAssistanceTitle: {
    marginBottom: "16px",
    fontSize: "30px",
    fontWeight: "bold",
    color: ColorTokens.foreground
  } as IStyle,
  immediateAssistanceDescription: {
    margin: "0 auto 48px",
    maxWidth: "512px",
    color: ColorTokens.mutedForeground
  } as IStyle,
  contactMethodsGrid: {
    display: "grid",
    gap: "32px",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))"
  } as IStyle,
  contactMethod: {
    textAlign: "center"
  } as IStyle,
  contactMethodIconContainer: {
    marginBottom: "16px",
    display: "flex",
    justifyContent: "center"
  } as IStyle,
  contactMethodIcon: {
    display: "flex",
    height: "64px",
    width: "64px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: ColorTokens.supportBlueLight,
    color: ColorTokens.supportBlue,
    transition: "all 0.2s ease"
  } as IStyle,
  contactMethodTitle: {
    marginBottom: "8px",
    fontWeight: "600",
    color: ColorTokens.foreground
  } as IStyle,
  contactMethodDescription: {
    fontSize: "14px",
    color: ColorTokens.mutedForeground
  } as IStyle,
  supportCard: {
    overflow: "hidden",
    border: "1px solid hsl(212, 80%, 85%, 0.2)",
    background: ColorTokens.gradientCard,
    borderRadius: "8px",
    transition: "all 0.3s ease",
    position: "relative",
    zIndex: 200,
    paddingBottom: "60px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
  } as IStyle,
  supportCardImageContainer: {
    aspectRatio: "16/10",
    overflow: "hidden"
  } as IStyle,
  supportCardImage: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
    transition: "transform 0.3s ease"
  } as IStyle,
  supportCardContent: {
    marginLeft: "20px",
    marginRight: "20px"
  } as IStyle,
  supportCardTitle: {
    marginBottom: "5px",
    fontSize: "20px",
    fontWeight: "600",
    color: ColorTokens.foreground
  } as IStyle,
  supportCardDescription: {
    marginBottom: "10px",
    fontSize: "12px",
    lineHeight: "1.6",
    fontFamily: "Roboto,sans-serif",
    color: ColorTokens.mutedForeground
  } as IStyle,
  supportCardActions: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  } as IStyle,
  supportCardPrimaryButton: {
    width: "calc(100% - 32px)",
    background: ColorTokens.gradientSupport,
    color: "white",
    fontWeight: "500",
    border: "none",
    borderRadius: "6px",
    padding: "16px 24px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.2s ease",
    position: "absolute",
    left: 16,
    right: 16,
    bottom: 16,
    margin: 0
  } as IStyle,
  supportCardSecondaryButton: {
    width: "100%",
    background: "transparent",
    color: ColorTokens.mutedForeground,
    border: "none",
    borderRadius: "6px",
    padding: "12px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "color 0.2s ease"
  } as IStyle
});
